export default {
  "hierarchy": {
    "bottom": [
      "tabPane-bottom"
    ],
    "mobileDetailViewTabs": [
      "tabPane-mobileDetailViewTabs"
    ],
    "detailViewTabs": [
      "tabPane-detailViewTabs"
    ],
    "settingsTabs": [
      "tabPane-detailViewTabs",
      "tabPane-settingsTabs"
    ],
    "tempUser": [
      "tabPane-tempUser"
    ],
    "salesFlow": [
      "tabPane-salesFlow"
    ]
  },
  "props": {
    "default": {},
    "bottom": {},
    "mobileDetailViewTabs": {},
    "detailViewTabs": {},
    "settingsTabs": {},
    "tempUser": {},
    "salesFlow": {}
  }
}